import React, { useState, useRef } from "react";
import "../loginSignupPage.css";

import { useForgetPassword } from "../../../contexts/ForgetPasswordContext";
import { toast } from "react-toastify";
import { useNavigate, Navigate } from "react-router-dom";

import Loader from "../../commonComponents/Loader/Loader";

import InputBox from "../../commonComponents/inputComponents/InputBox";

export default function FPStep3() {
  const [isLoading, setIsLoading] = useState(false);
  const { thirdStep, allowThirdStep } = useForgetPassword();
  const passwordRef = useRef();
  const confPasswordRef = useRef();
  const navigate = useNavigate();

  if (!allowThirdStep()) return <Navigate to="/forget-password" />;

  async function handleSubmit(e) {
    e.preventDefault();
    setIsLoading(true);

    const password = passwordRef.current.value;
    const confirmPassword = confPasswordRef.current.value;

    if (!password || !confirmPassword) {
      toast.error("لطفا اطلاعات را وارد کنید");
      setIsLoading(false);
      return;
    }

    if (password !== confirmPassword) {
      toast.error("رمز عبور با تکرار آن همخوانی ندارد");
      setIsLoading(false);
      return;
    }

    try {
      await thirdStep(password);
    } catch (error) {
      toast.error(error);
      setIsLoading(false);
      return;
    }

    setIsLoading(false);
    navigate("/login");
  }

  return (
    <form action="" className="log_sign-form" onSubmit={handleSubmit}>
      <h2 className="forget-pass-header">رمز عبور جدید را وارد کنید</h2>
      <InputBox
        name="forget-pass"
        label="رمز عبور جدید"
        type="password"
        gap="60px"
        ref={passwordRef}
      />
      <InputBox
        name="forget-pass-conf"
        label="تایید رمز عبور جدید"
        type="password"
        gap="60px"
        ref={confPasswordRef}
      />
      <button disabled={isLoading} className="log_sign-button red-submit-btn">
        {isLoading ? <Loader loading={isLoading} small dark /> : "ثبت تغییرات"}
      </button>
    </form>
  );
}
